import { RUHSAT_SORU_CEVAP_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const ruhsatSoruCevapList = (basvuruId,relAllRecord) => {
    return getRequest({ url: RUHSAT_SORU_CEVAP_LISTESI + "?basvuruId=" + basvuruId + "&relAllRecord=" + relAllRecord });
}

export default ruhsatSoruCevapList;